<template>
  <MainPageBlockWrapperNew :title="title">
    <div
      class="flex grid-cols-4 grid-rows-2 flex-wrap justify-between gap-[20px] xl:grid"
    >
      <MainPageCardsReworkedBaseCard
        class="col-span-full w-full md:w-[48.555%] lg:col-span-2 lg:col-start-1 lg:row-span-2 xl:col-start-2 xl:w-full"
        disable-label
        :data="data[0]"
        disable-title
        disable-announce
        disable-author
        :animation="false"
      ></MainPageCardsReworkedBaseCard>
      <MainPageCardsReworkedBaseCard
        class="col-span-full w-full md:w-[48.555%] lg:col-span-2 lg:col-start-3 lg:row-start-1 xl:col-span-1 xl:w-full"
        disable-label
        is-blank
        :data="data[1]"
        disable-title
        disable-announce
        disable-author
        :animation="false"
      ></MainPageCardsReworkedBaseCard>
      <MainPageCardsReworkedBaseCard
        class="col-span-full w-full md:w-[48.555%] lg:col-span-2 lg:col-start-3 lg:row-start-2 xl:col-span-1 xl:w-full"
        disable-label
        disable-title
        :data="data[2]"
        disable-announce
        disable-author
        :animation="false"
      ></MainPageCardsReworkedBaseCard>
      <MainPageCardsReworkedBaseCard
        class="col-span-full w-full md:w-[48.555%] lg:col-span-1 lg:col-start-4 lg:row-start-1 xl:w-full"
        disable-label
        is-blank
        :data="data[3]"
        disable-title
        disable-announce
        disable-author
        :animation="false"
      ></MainPageCardsReworkedBaseCard>
      <MainPageCardsReworkedBaseCard
        class="col-span-full w-full md:w-[48.555%] lg:col-span-1 lg:col-start-4 lg:row-start-2 xl:block xl:w-full"
        disable-label
        is-blank
        disable-title
        :data="data[4]"
        disable-announce
        disable-author
        :animation="false"
      ></MainPageCardsReworkedBaseCard>
    </div>
  </MainPageBlockWrapperNew>
</template>

<script setup>
defineProps({
  data: {
    type: Array,
    default: () => [],
    require: true,
  },
  title: {
    type: String,
    default: '',
  },
});
</script>
